import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "gfu-gift-card-picker__name-wrapper" }
const _hoisted_2 = {
  class: "gfu-gift-card-picker__balance",
  "data-qa": "gift-card:CurrentBalance"
}
const _hoisted_3 = {
  class: "gfu-gift-card-picker__name",
  "data-qa": "gift-card:Name"
}
const _hoisted_4 = {
  class: "gfu-gift-card-picker__applied",
  "data-qa": `gift-card:AppliedAmount`
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_select_card = _resolveComponent("select-card")

  return (_openBlock(), _createBlock(_component_select_card, {
    "model-value": $options.isSelected,
    "is-disabled": $options.isDisabled,
    badges: $options.badges,
    "onUpdate:modelValue": $options.setGiftCardSelected,
    "data-qa": `gift-card-item:${$props.giftCard.giftCardID}`
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString($options.formattedBalance), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_3, _toDisplayString($props.giftCard.name), 1 /* TEXT */)
      ]),
      ($props.giftCard.publicNote)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            text: $props.giftCard.publicNote,
            class: "gfu-gift-card-picker__tooltip",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, { name: "circle-info" })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["text"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    ($options.appliedAmount > 0)
      ? {
          name: "details",
          fn: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Checkout.GiftCardPickerAppliedAmountText, $options.formattedAppliedAmount)), 1 /* TEXT */)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["model-value", "is-disabled", "badges", "onUpdate:modelValue", "data-qa"]))
}